import { Addition } from "../CalculationsWithDecimalValues";

export const CalculateTaxForCommonTax = (Selected_Taxes, totalAmount, Invoice_Type, FormData) => {
  let results = [];
  let total = totalAmount;

  Selected_Taxes?.forEach((el) => {

    const additionalAmount = FormData?.RCM
      ? 0
      : ((Number(el?.Tax_Rate?.Tax_Percentage) / 100) * Number(totalAmount)).toFixed(2) || 0;

    total = FormData?.RCM ? total : Addition(Number(total), additionalAmount);



    results.push({
      Name: el.Tax_Name,
      Rate: el?.Tax_Rate?.Tax_Percentage,
      Tax_Type: el.Tax_Type,
     
      Taxable_Amount: total,
      // Transaction_Type: "Dr",
      Transaction_Type: Invoice_Type === "Sales" ? "Cr" : Invoice_Type === "Purchase" ? "Dr" : "",
      Input_Account: el.Input_Account,
      Output_Account: el.Output_Account,

      Amount: additionalAmount,
    });
  });
  //   results.push({
  //     Name: "Total",

  //     Amount: total || 0,
  //     Transaction_Type:
  //       Invoice_Type === "Sales" ? "Dr" : Invoice_Type === "Purchase" ? "Cr" : "",
  //     // Add_Deduct: "Deduct",
  //     Calculation_Type: "Total",
  //   });

  return results;
};

export const BillTotal = (data) => {
  const sum = data.reduce((accumulator, currentValue) => {
    return Addition(accumulator, Number(currentValue.Amount));
  }, 0);
  return sum;
};


export const MainBillTotal = (data) => {
  let sum = 0;
  data.forEach((el, i) => {

    if (el.Name !== "Total") {
      sum = Addition(sum, Number(el.Amount));
    }
  }, 0);
  return sum;
};